import { Box, NumberInput, Popover, Slider } from "@wix/design-system";
import React, { useRef, useState } from "react";
const InputWithSlider = ({
  value,
  onChange,
  gradientColor,
  zIndex,
  suffix,
  min,
  max,
  dataHook
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const inputRef = useRef(null);
  const inputWrapperRef = React.useRef(null);
  const [inputValue, setInputValue] = useState(value);
  const [inputKey, setInputKey] = useState(0);
  const inputWrapperDimensions = inputWrapperRef.current?.getBoundingClientRect() ?? { width: 0 };
  const popoverZIndex = `calc(${zIndex} + 100)`;
  const numberInputZIndex = `calc(${popoverZIndex} + 1)`;
  const rightPadding = 6;
  React.useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);
  const handleInputWithinBounds = (data) => {
    const numberValue = Math.round(Number(data));
    const valueWithinBounds = isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue;
    setInputValue(valueWithinBounds);
    if (value !== valueWithinBounds) {
      onChange(valueWithinBounds);
      return;
    }
    setInputKey((prev) => prev + 1);
  };
  return /* @__PURE__ */ React.createElement(
    Popover,
    {
      shown: isFocused,
      placement: "right",
      moveBy: { x: -1 * inputWrapperDimensions.width - rightPadding },
      zIndex: popoverZIndex,
      onClickOutside: () => setIsFocused(false)
    },
    /* @__PURE__ */ React.createElement(Popover.Element, null, /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: inputWrapperRef,
        style: isFocused ? { position: "relative", zIndex: numberInputZIndex } : void 0
      },
      /* @__PURE__ */ React.createElement(
        NumberInput,
        {
          inputRef,
          key: inputKey,
          size: "small",
          suffix,
          value: inputValue,
          min,
          max,
          onFocus: () => {
            setIsFocused(true);
          },
          onChange: (value2, stringValue) => {
            if (stringValue === "") {
              setInputValue("");
              return;
            }
            if (typeof value2 === "number") {
              onChange(value2);
              setInputValue(value2);
            }
          },
          onBlur: (e) => handleInputWithinBounds(e.target.value),
          onKeyDown: (e) => {
            if (["Enter", "Esc"].includes(e.key)) {
              handleInputWithinBounds(inputRef.current?.value);
            }
          },
          hideStepper: true,
          dataHook
        }
      )
    )),
    /* @__PURE__ */ React.createElement(Popover.Content, null, /* @__PURE__ */ React.createElement(Box, { padding: `6px ${rightPadding}px 6px 12px`, gap: "SP3" }, /* @__PURE__ */ React.createElement(Box, { width: 88 }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        gradientColor,
        displayMarks: false,
        min,
        max,
        value,
        onChange: (value2) => onChange(typeof value2 === "number" ? value2 : value2[0]),
        displayTooltip: false
      }
    )), /* @__PURE__ */ React.createElement(Box, { width: inputWrapperDimensions.width })))
  );
};
export {
  InputWithSlider
};
//# sourceMappingURL=input-with-slider.js.map
